import React, { useState } from "react";
import {
  FaAndroid,
  FaDesktop,
  FaGlobe,
  FaMobileAlt,
  FaShoppingCart,
  FaUserTie,
} from "react-icons/fa";
import { MdOutlineSupervisorAccount } from "react-icons/md";
import Buyer_Send_request_supllier from "../../../assets/Docs/Buyer_Send_request_supllier.png";
import buyer_request_supllier from "../../../assets/Docs/buyer_request_supllier.png";
import Already_requested_supplier from "../../../assets/Docs/Already_requested_supplier.png";
import Distributor_Request from "../../../assets/Docs/Distributor_Request.png";
import Confirm_Request from "../../../assets/Docs/Confirm_Request.png";
import Select_distributor_role from "../../../assets/Docs/Select_distributor_role.png";
import View_Distributors from "../../../assets/Docs/View_Distributors.png";
import { TagComponent } from "../Tabs";

const Distributor = () => {
  const [activeTab2, setActiveTab2] = useState("web");

  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];

  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
            ? "bg-[#1a9588] text-white shadow"
            : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            } ${tab.disabled ? "opacity-50 cursor-not-allowed hover:bg-[#dbf4f1]" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );


  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">


      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <MdOutlineSupervisorAccount className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Distributors</h1>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="green" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>


      <p className="text-start mb-6 text-gray-600 ">
        You can set up a private dealer network exclusively for your
        distributor. This allows the distributor to receive orders from their
        dealers while keeping all order details and dealer network information
        confidential.
      </p>
      <p className="text-start mb-6 text-gray-600 ">
        First, create a distributor and then link that distributor to a user
        with the role type set as “Distributor.”
      </p>

      <div className="text-start my-4">
        <h3 className="text-2xl text-gray-500 font-semibold mb-2">
          {" "}
          Buyer searches supplier
        </h3>
        <p className="text-gray-400 mb-6">
          The buyer searches for a supplier using the Supplier ID.
        </p>
      </div>

      {renderTabs(activeTab2, setActiveTab2)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={Buyer_Send_request_supllier}
          alt={`${activeTab2} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>

      <div className="text-start my-4">
        <h3 className="text-2xl text-gray-500 font-semibold mb-2">
          {" "}
          Supplier details displayed
        </h3>
        <p className="text-gray-400 mb-6">
          The system will show the supplier’s details based on the entered ID.
        </p>
      </div>
      {renderTabs(activeTab2, setActiveTab2)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={buyer_request_supllier}
          alt={`${activeTab2} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>

      <div className="text-start my-4">
        <h3 className="text-2xl text-gray-500 font-semibold mb-2"> Pending state</h3>
        <p className="text-gray-400 mb-6">
          Until the supplier accepts the request, the status will remain as
          “Already Requested.”
        </p>
      </div>
      {renderTabs(activeTab2, setActiveTab2)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={Already_requested_supplier}
          alt={`${activeTab2} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>

      <div className="text-start my-4">
        <h3 className="text-2xl text-gray-500 font-semibold mb-2"> Supplier accepts</h3>
        <p className="text-gray-400 mb-6">
          Once the supplier accets the request, a confirmation step will
          appear.
        </p>
      </div>
      {renderTabs(activeTab2, setActiveTab2)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={Distributor_Request}
          alt={`${activeTab2} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>

      <div className="text-start my-4">
        <h3 className="text-2xl text-gray-500 font-semibold mb-2"> Confirmation</h3>
        <p className="text-gray-400  mb-6">
          At this stage, confirmation will be asked before proceeding.
        </p>
      </div>
      {renderTabs(activeTab2, setActiveTab2)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={Confirm_Request}
          alt={`${activeTab2} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>

      <div className="text-start my-4">
        <h3 className="text-2xl text-gray-500 font-semibold mb-2"> Role selection</h3>
        <p className="text-gray-400 mb-6">
          After confirmation, the user can choose whether they want to connect
          as a Distributor or as a Buyer.
        </p>
      </div>
      {renderTabs(activeTab2, setActiveTab2)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={Select_distributor_role}
          alt={`${activeTab2} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>

      <div className="mt-4 bg-yellow-100 text-orange-600 p-3 rounded text-start">
        Distributor Code once defined, cannot be changed.
      </div>

      <div className="text-start my-4">
        <h3 className="text-2xl text-gray-500 font-semibold mb-2"> Final connection</h3>
        <p className="text-gray-400 mb-6">
          Based on the selected role, the buyer and supplier will be
          successfully connected.
        </p>
      </div>
      {renderTabs(activeTab2, setActiveTab2)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={View_Distributors}
          alt={`${activeTab2} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>
    </div>
  );
};

export default Distributor;
